import { Button, type TPlacement, TooltipDesktop } from '@cian/ui-kit';
import { IconFunctionalWarningSign16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC, type SyntheticEvent, useCallback } from 'react';

import { useComplaintToOfferAction } from '@/microfrontends/listing/shared/hooks/card/useComplaintToOfferAction';

import { ControlWrapper } from '../components/Controls';

type ComplaintContainerProps = {
  tooltipPlacement?: TPlacement;
};

export const ComplaintContainer: FC<ComplaintContainerProps> = props => {
  const { tooltipPlacement = 'left' } = props;
  const complaintToOffer = useComplaintToOfferAction();

  const handleClick = useCallback(
    (e: SyntheticEvent) => {
      e.stopPropagation();
      complaintToOffer();
    },
    [complaintToOffer],
  );

  return (
    <ControlWrapper>
      <TooltipDesktop placement={tooltipPlacement} theme="black" title="Пожаловаться">
        <Button
          beforeIcon={<IconFunctionalWarningSign16 />}
          data-testid="ComplaintControl"
          size="XS"
          theme="stroke_secondary"
          onClick={handleClick}
        />
      </TooltipDesktop>
    </ControlWrapper>
  );
};
